"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as r } from "react";
import t from "../components/Icon/SvgIcon.js";
const l = (o) => /* @__PURE__ */ e(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S16.825 3.25 12 3.25M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M8.368 9.536q0-.69.442-1.398.443-.71 1.293-1.173.851-.465 1.984-.465 1.054 0 1.86.39.806.387 1.247 1.054.439.67.44 1.454 0 .618-.252 1.083-.25.465-.596.803-.345.337-1.238 1.137-.248.225-.396.395a1.7 1.7 0 0 0-.222.313 1.6 1.6 0 0 0-.112.284q-.04.141-.12.497-.138.756-.865.756a.88.88 0 0 1-.636-.247q-.258-.247-.258-.734 0-.61.19-1.057.188-.447.501-.784.313-.339.842-.804.466-.406.672-.613t.35-.46a1.1 1.1 0 0 0 .141-.554 1.28 1.28 0 0 0-.433-.98q-.432-.401-1.115-.4-.8 0-1.176.402-.38.404-.64 1.19-.248.82-.938.82a.93.93 0 0 1-.686-.287q-.279-.286-.279-.622m2.771 7.676q.33.287.773.288.43 0 .756-.291.329-.29.328-.8 0-.457-.313-.769a1.05 1.05 0 0 0-.77-.313q-.465 0-.785.313-.32.312-.32.769 0 .517.331.803",
        clipRule: "evenodd"
      }
    )
  }
), n = r(l);
export {
  n as CustomerService,
  n as default
};
